module.exports = __webpack_public_path__ + "img/madamefin-logo.80970aeb.png";